export const authLinks = {
  LOGIN: '/account/login',
  REGISTER: '/account/register',
  FORGOT_PASSWORD: '/account/forgot-password',
  RESET_PASSWORD: '/account/reset-password'
}

export const accountLinks = {
  PROFILE: '/account/profile',
  DASHBOARD: '/account/dashboard',
}

export const checkoutLinks = {
  CHECKOUT: '/checkout',
}

export const utilityLinks = {
  PRIVACY_POLICY: 'https://www.relias.com/legal/privacy-policy',
  CANCELLATION_POLICY: '/courses/cancellation-policy',
  TERMS_CONDITIONS: '/terms-conditions',
  NAWCO_APPLICATION: 'https://www.nawccb.org/exam-page',
  ADMISSIONS_TEAM_NUMBER: '877-462-9234',
  COURSES_PAGE: '/courses',
  WEBINARS_PAGE: '/courses/webinars',
}
